import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {FormGroupComponent} from '../../../components/form-inputs/form-group/form-group.component';
import {UserSessionService} from '../../../services/user-session.service';
import {FormErrorService} from '../../../services/form-error.service';

@Component({
  selector: 'app-auth-two-factor-challenge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    FormGroupComponent
  ],
  templateUrl: './challenge.component.html'
})
export class ChallengeComponent {
  public form = new FormGroup({
    code: new FormControl<string>('', [Validators.required]),
  });

  public constructor(
    private userSessionService: UserSessionService,
    private router: Router,
    private formErrorService: FormErrorService,
  ) {}

  public submit() {
    const code = this.form.controls.code.value;
    if (code) {
      this.userSessionService.submitTwoFactorAuthChallenge(code).subscribe({
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      })
    }
  }
}
